var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mob_layout"}},[_c('GlobalHeaderMob'),_c('div',{staticClass:"box90"}),_c('router-view'),_c('GlobalFooterMob')],1)}
var staticRenderFns = []

export { render, staticRenderFns }